<template>
  <layout-main-inner title="会员信息">
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">
        <el-button
          type="primary"
          @click="userSettings">会员设置</el-button>
        <el-button
          type="primary"
          @click="download">导出用户信息</el-button>
      </template>
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0">
        <!-- <el-form-item label="加入时间：">
          <el-date-picker
            v-model="searchForm.time"
            style="width:300px"
            type="daterange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item style="margin-bottom: 0">
          <!-- <el-radio-group
            v-model="searchForm.checked"
            @change="handleChange">
            <el-radio-button :label="0">全部</el-radio-button>
            <el-radio-button :label="1">非会员</el-radio-button>
          </el-radio-group> -->
          <el-select
            v-model="config.userLevel"
            placeholder="请选择">
            <el-option
              v-for="item in levelList"
              :key="item.level"
              :label="item.levelName"
              :value="item.level">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label=""
          style="margin-bottom: 0"
          prop="userName">
          <el-input
            v-model="config.userName"
            clearable=""
            placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item
          label=""
          style="margin-bottom: 0"
          prop="mobilePhone">
          <el-input
            v-model="config.mobilePhone"
            clearable=""
            placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 0">
          <el-button
            type="primary"
            @click="handleCurrentChange(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        border
        :data="list">
        <!-- <el-table-column
          label="微信Openid"
          prop="wxOpenid"
          width="220">
          <template slot-scope="{ row }">
            <link-route :link-to="`/memberdetail?userId=${row.userId}&vendorId=${userInfo.vendorId}`">
              {{ row.wxOpenid }}
            </link-route>
          </template>
        </el-table-column> -->
        <el-table-column
          label="ID"
          :resizable="false"
          prop="userId"
          width="70"></el-table-column>
        <el-table-column
          label="姓名"
          :resizable="false"
          min-width="130"
          prop="userName">
          <template slot-scope="{ row }">
            <link-route :link-to="`/wxapp-user-detail?userId=${row.userId}&vendorId=${userInfo.orgId}`">
              {{ row.userName }}
            </link-route>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
          :resizable="false"
          prop="mobilePhone"
          width="110"></el-table-column>
        <!-- <el-table-column
          label="昵称"
          :resizable="false"
          prop="nickname"
          width="100"></el-table-column>
        <el-table-column
          label="性别"
          :resizable="false"
          width="60">
          <template slot-scope="{ row }">
            {{ row.gender | genderFormat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="所在地"
          min-width="180"
          :resizable="false">
          <template slot-scope="scope">
            <span>{{ scope.row.country }}{{ scope.row.province }}{{ scope.row.city }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="标签"
          :resizable="false"
          width="160">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.agentFlag === 1"
              style="margin-right: 10px"
              type="success">合伙人</el-tag>
            <el-tag
              v-if="scope.row.staffFlag === 1"
              type="success">企业人员</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="会员等级"
          :resizable="false"
          prop="userLevelName"></el-table-column>
        <el-table-column
          width="100"
          label="累计消费"
          :resizable="false"
          prop="totalOrderAmount"></el-table-column>
        <el-table-column
          width="100"
          label="钱包余额"
          :resizable="false"
          prop="balance"></el-table-column>
        <el-table-column
          label="当前积分"
          width="90"
          :resizable="false">
          <template slot-scope="{ row }">
            <link-route
              v-if="row.totalPoints"
              @click.native="integral(row)">
              {{ row.totalPoints }}
            </link-route>
          </template>
        </el-table-column>
        <el-table-column
          label="加入时间"
          :resizable="false"
          width="140px">
          <template slot-scope="{ row }">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          :resizable="false"
          width="190">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="setvendoradminuser(row)">设为企业人员</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                会员等级
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in levelList"
                  :key="item.level"
                  :disabled="row.userLevel === 0"
                  @click.native="setLevel(item.level,item.levelName, row)">设为{{ item.levelName }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <member-integral-modal ref="modal" />
    <staff-select-modal
      ref="staff"
      :autoClose="false"
      :callback="staffcallback" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import MemberIntegralModal from './busi/member-integral-modal.vue'

import moment from 'moment'
import StaffSelectModal from '../staff-select-modal.vue'
export default {
  name: 'WxappUserList',
  components: { MemberIntegralModal, StaffSelectModal },
  filters: {
    genderFormat(value) {
      const status = { 0: '未知', 1: '男', 2: '女' }
      return status[value]
    }
  },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      searchForm: { time: null, checked: 1 },
      config: { pageNum: 1, pageSize: 10, userName: '', mobilePhone: '', userLevel: null },
      current: {},
      levelList: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
    this.fetchMemberLevels()
  },
  methods: {
    userSettings() {
      this.$router.push(`/wxapp-user-setting`)
    },
    handleChange() {
      this.fetchList()
    },
    integral(row) {
      this.$refs.modal.fetch(row.vendorId, row.userId, row)
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const time = this.searchForm.time || []
      this.$store.dispatch('member/getmyusers', {
        payload: {
          ...this.config,
          beginTime: time[0] ? +moment(+time[0]).startOf('days') : null,
          endTime: time[1] ? +moment(+time[1]).endOf('days') : null
          // isMember: this.searchForm.checked ? true : null
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    setvendoradminuser(row) {
      this.current = row
      this.$refs.staff.fetch()
      // this.$confirm('是否将该会员设为企业人员?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.loading = true
      //   this.$store.dispatch('account/setvendoradminuser', {
      //     payload: {
      //       userId: row.userId,
      //       vendorId: row.vendorId
      //     },
      //     success: () => {
      //       this.loading = false
      //       this.fetchList()
      //     },
      //     fail: () => {
      //       this.loading = false
      //     }
      //   })
      // })
    },
    setLevel(level, levelName, row) {
      this.$confirm(`是否将该会员设为${levelName}?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('member/wxupdateuser', {
            payload: { userId: row.userId, userLevel: level },
            success: () => {
              this.loading = false
              this.$message.success('设置成功')
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    staffcallback(row) {
      this.$confirm('是否将该会员设为企业人员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('member/bindstaff', {
          payload: {
            userId: this.current.userId,
            staffId: row.staffId
          },
          success: () => {
            this.loading = false
            this.fetchList()
            this.$refs.staff.toggleModal(false)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    download() {
      this.loading = true
      const time = this.searchForm.time || []
      this.$store.dispatch('member/downloadusers', {
        payload: {
          vendorId: this.userInfo.vendorId,
          beginDate: time[0] ? moment(+time[0]).format('YYYYMMDD') : null,
          endDate: time[1] ? moment(+time[1]).format('YYYYMMDD') : null,
          isMember: this.searchForm.checked ? 1 : null
        },
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchMemberLevels() {
      this.$store.dispatch('member/getmemberlevels', {
        payload: { vendorId: this.userInfo.vendorId },
        success: res => {
          this.levelList = [{ level: null, levelName: '全部' }, { level: 0, levelName: '非会员' }, ...res.data.records]
        },
        fail: () => { }
      })
    }
  }
}
</script>
